import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  withStyles,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Tooltip,
  Button,
  IconButton,
  Icon,
  Card,
  CardHeader,
  CardContent,
} from '@material-ui/core';
import MaterialTable from 'material-table';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ClearIcon from '@material-ui/icons/Clear';
import {
  getTenantUserRequests,
  updateTenantUserRequest,
} from '@pingum/app-state-management/tenant/actions';
import { showLogsModal } from '@pingum/app-state-management/log/actions';

import AuditLogsButton from '../../../widgets/AuditLogsButton';
import styles from './styles';

export class UserRequestsCardComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      openConfirmRejectRequestDialog: false,
      selectedRejectUser: {},
      openConfirmAcceptRequestDialog: false,
      selectedAcceptUser: {},
    };

    this.props.getTenantUserRequests(this.props.tenantName);
  }

  handleRejectClickOpen = (user) => {
    this.setState({
      openConfirmRejectRequestDialog: true,
      selectedRejectUser: user,
    });
  }

  handleRejectClickClose = () => {
    this.setState({
      openConfirmRejectRequestDialog: false,
      selectedRejectUser: {},
    });
  }

  handleRejectConfirm = () => {
    this.props.updateTenantUserRequest(this.state.selectedRejectUser.id, false);
    this.setState({
      openConfirmRejectRequestDialog: false,
      selectedRejectUser: {},
    });
  }

  handleAcceptClickOpen = (user) => {
    this.setState({
      openConfirmAcceptRequestDialog: true,
      selectedAcceptUser: user,
    });
  }

  handleAcceptClickClose = () => {
    this.setState({
      openConfirmAcceptRequestDialog: false,
      selectedAcceptUser: {},
    });
  }

  handleAcceptConfirm = () => {
    this.props.updateTenantUserRequest(this.state.selectedAcceptUser.id, true);
    this.setState({
      openConfirmAcceptRequestDialog: false,
      selectedAcceptUser: {},
    });
  }

  showLogsModal = () => {
    this.props.showLogsModal({
      tenantName: this.props.tenantName,
      service: 'tenant',
      actions: ['User Requested Access To Organization', 'Organization Access Request Updated'],
    });
  }

  render() {
    const { classes } = this.props;
    return (
      <div>
        <Card>
          <CardHeader
            title="Requests to Join Organization"
            subheader="Accept or Decline user requests to join your organization"
            action={(
              <div>
                <AuditLogsButton onClick={this.showLogsModal} />
              </div>
            )}
          />
          <CardContent>
            {
              this.props.tenantUserRequests.length <= 0
                ? (
                  <div className={classes.noRequests}>
                    <Icon className={classes.noRequestsIcon}>
                      check_circle
                    </Icon>
                    <h4 name="no-requests-description">
                      There are currently no requests to join this organization.
                    </h4>
                  </div>
                )
                : (
                  <MaterialTable
                    data={this.props.tenantUserRequests}
                    columns={[
                      {
                        title: 'Email',
                        field: 'email',
                      },
                      {
                        title: 'Last Name',
                        field: 'lastName',
                      },
                      {
                        title: 'First Name',
                        field: 'firstName',
                      },
                      {
                        title: 'Actions',
                        render: (userRequest) => (
                          <div className="actions-right">
                            {
                              this.props.isFetching
                                ? (
                                  <CircularProgress
                                    size={20}
                                    style={{
                                      marginLeft: 10,
                                      float: 'left',
                                    }}
                                    color="inherit"
                                  />
                                )
                                : (
                                  <span>
                                    <Tooltip title="Accept Request" id={'accept-request-tooltip'.concat(userRequest.email)}>
                                      <IconButton onClick={() => { this.handleAcceptClickOpen(userRequest); }} color="primary">
                                        <CheckCircleIcon />
                                      </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Reject Request" id={'reject-request-tooltip'.concat(userRequest.email)}>
                                      <IconButton onClick={() => { this.handleRejectClickOpen(userRequest); }}>
                                        <ClearIcon />
                                      </IconButton>
                                    </Tooltip>
                                  </span>
                                )
                            }
                          </div>
                        ),
                      },
                    ]}
                  />
                )
              }
          </CardContent>
        </Card>
        <Dialog
          open={this.state.openConfirmRejectRequestDialog}
          onClose={this.handleCloseRejectRequestDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          id="reject-request-dialog"
        >
          <DialogTitle id="alert-dialog-title">Confirm Action</DialogTitle>
          <DialogContent>
            <DialogContentText id="reject-dialog-description">
              Are you sure you want to reject the request to join submitted by
              {' '.concat(this.state.selectedRejectUser.email === undefined
                ? ''
                : this.state.selectedRejectUser.email)}? This action cannot be undone.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => { this.handleRejectClickClose(); }}
              id="cancel-accept-button"
            >
              Cancel
            </Button>
            <Button
              onClick={() => { this.handleRejectConfirm(); }}
              color="primary"
              autoFocus
              id="confirm-accept-button"
            >
              Reject Request
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={this.state.openConfirmAcceptRequestDialog}
          onClose={this.handleCloseAcceptRequestDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          id="accept-request-dialog"
        >
          <DialogTitle id="alert-dialog-title">Confirm Action</DialogTitle>
          <DialogContent>
            <DialogContentText id="accept-dialog-description">
              Are you sure you want to accept the request to join submitted by
              {' '.concat(this.state.selectedAcceptUser === undefined
                ? ''
                : this.state.selectedAcceptUser.email)}?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => { this.handleAcceptClickClose(); }}
              id="cancel-reject-button"
            >
              Cancel
            </Button>
            <Button
              onClick={() => { this.handleAcceptConfirm(); }}
              color="primary"
              autoFocus
              id="confirm-reject-button"
            >
              Accept Request
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

UserRequestsCardComponent.propTypes = {
  classes: PropTypes.object.isRequired,
  tenantName: PropTypes.string.isRequired,
  getTenantUserRequests: PropTypes.func.isRequired,
  tenantUserRequests: PropTypes.array.isRequired,
  updateTenantUserRequest: PropTypes.func.isRequired,
  isFetching: PropTypes.bool.isRequired,
  showLogsModal: PropTypes.func.isRequired,
};

export const mapStateToProps = (state) => ({
  tenantUserRequests: state.tenant.tenantUserRequests,
  isFetching: state.tenant.isFetchingTenantUserRequests,
});

export const mapDispatchToProps = (dispatch) => ({
  getTenantUserRequests: (tenantName) => dispatch(getTenantUserRequests(tenantName)),
  updateTenantUserRequest: (requestId, accepted) => dispatch(updateTenantUserRequest(requestId, accepted)),
  showLogsModal: (request) => dispatch(showLogsModal(request)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(UserRequestsCardComponent));
